<div
  class="w-full flex relative"
  [class.flex-row]="!isTextarea"
  [class.flex-col]="isTextarea"
  [class.bm-join]="!isTextarea"
>
  @switch (modus) {
    @case ("text") {
      <input
        type="text"
        class="bm-input bm-input-sm bm-join-item w-full"
        [(ngModel)]="value"
        [maxlength]="maxInputLength"
        [class.uppercase]="upperCaseMode"
        (keydown.enter)="save()"
        (keydown.esc)="cancel()"
      />
    }
    @case ("number") {
      <input
        type="number"
        class="bm-input bm-input-sm bm-join-item w-full"
        [(ngModel)]="value"
        [maxlength]="maxInputLength"
        (keydown.enter)="save()"
        (keydown.esc)="cancel()"
      />
    }
    @case ("textarea") {
      <textarea
        class="bm-textarea bm-textarea-sm bm-join-item pr-8 w-full"
        [(ngModel)]="value"
        [maxlength]="maxInputLength"
        [class.uppercase]="upperCaseMode"
        (keydown.esc)="cancel()"
      >
        Text
      </textarea>
    }
    @case ("date") {
      <input
        class="bm-input bm-input-sm bm-join-item w-full"
        type="text"
        mwlFlatpickr
        [(ngModel)]="value"
        [locale]="'de'"
        [options]="datePickerConfig"
        [convertModelValue]="true"
        style="width: 150px"
      />
    }
    @case ("time") {
      <input class="bm-input bm-input-sm bm-join-item w-full" type="text" [(ngModel)]="value" />
    }
    @case ("select") {
      <select class="selectbox bm-select bm-select-sm bm-join-item w-full" [(ngModel)]="value" *ngIf="modus == 'select'">
        <option [value]="option.id" *ngFor="let option of selectOptions">
          {{ option.name }}
        </option>
      </select>
    }
    @case ("multiselect") {
      <mat-select
        style="border: 1px solid lightgray; font-size: 12px; padding: 3px"
        class="selectbox w-full"
        [(ngModel)]="value"
        multiple
      >
        @for (option of selectOptions; track option.id) {
          <mat-option [value]="option.id">
            {{ option.name }}
          </mat-option>
        }
      </mat-select>
    }
    @case ("checkbox") {
      <label class="bm-fieldset-label bm-join-item w-full w-full">
        <input type="checkbox" class="bm-checkbox bm-checkbox-sm" [(ngModel)]="value" (keydown.esc)="cancel()" />
        @if (value) {
          {{ checkdLabel }}
        } @else {
          {{ uncheckedLabel }}
        }
      </label>
    }
    @case ("onlyNumber") {
      <input type="number" class="bm-input bm-input-sm bm-join-item w-full" [(ngModel)]="value" (keydown.esc)="cancel()" />
    }
  }

  @if (isTextarea) {
    <div class="flex flex-col-reverse justify-between absolute top-1 right-1 bottom-1">
      <ng-container *ngTemplateOutlet="tplButtons" />
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="tplButtons" />
  }
</div>

<ng-template #tplButtons>
  <button class="flex-none bm-join-item bm-btn bm-btn-primary bm-btn-sm bm-btn-square bm-tooltip" [attr.data-tip]="'Speichern'"  (click)="save()">
    <fa-icon [icon]="['far', 'save']" />
  </button>
  <button class="flex-none bm-join-item bm-btn bm-btn-sm bm-btn-square bm-tooltip"  [attr.data-tip]="'Verwerfen'" (click)="cancel()">
    <fa-icon [icon]="['far', 'times']" />
  </button>
</ng-template>
